requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded('details-disclosure.js', () => {
      if (!customElements.get('share-button')) {
        customElements.define(
          'share-button',
          class ShareButton extends DetailsDisclosure {
            constructor() {
              super();

              this.elements = {
                shareButton: this.querySelector('button'),
                shareSummary: this.querySelector('summary'),
                closeButton: this.querySelector('.share-button__close'),
                successMessage: this.querySelector('[id^="ShareMessage"]'),
                urlInput: this.querySelector('input'),
              };
              this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

              if (navigator.share) {
                this.mainDetailsToggle.setAttribute('hidden', '');
                this.elements.shareButton.classList.remove('hidden');
                this.elements.shareButton.addEventListener('click', async () => {
                  try {
                    await navigator.share({ url: this.urlToShare, title: document.title });
                  } catch (error) {
                    if (error.name !== 'AbortError' && this.isConnected) this.showManualCopy();
                  }
                });
              }
              {
                this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
                this.mainDetailsToggle
                  .querySelector('.share-button__copy')
                  .addEventListener('click', this.copyToClipboard.bind(this));
                this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
              }
            }

            close() {
              this.closeDefault();
            }

            toggleDetails() {
              if (!this.mainDetailsToggle.open) {
                this.copyRequestId = (this.copyRequestId || 0) + 1;
                this.elements.successMessage.classList.add('hidden');
                this.elements.successMessage.textContent = '';
                this.elements.closeButton.classList.add('hidden');
                this.elements.shareSummary.focus();
              }
            }

            showManualCopy() {
              this.mainDetailsToggle.removeAttribute('hidden');
              this.mainDetailsToggle.open = true;
              this.elements.shareButton.classList.add('hidden');
              this.elements.successMessage.classList.remove('hidden');
              this.elements.successMessage.textContent = this.dataset.copyError;
              this.elements.closeButton.classList.remove('hidden');
              this.elements.urlInput.focus();
              this.elements.urlInput.select();
            }

            async copyToClipboard() {
              const requestId = this.copyRequestId = (this.copyRequestId || 0) + 1;
              const url = this.elements.urlInput.value;
              const isCurrent = () => this.isConnected && this.mainDetailsToggle.open && requestId === this.copyRequestId && url === this.elements.urlInput.value;
              try {
                if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
                await navigator.clipboard.writeText(url);
                if (!isCurrent()) return;
                this.elements.successMessage.classList.remove('hidden');
                this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
                this.elements.closeButton.classList.remove('hidden');
                this.elements.closeButton.focus();
              } catch {
                if (isCurrent()) this.showManualCopy();
              }
            }

            updateUrl(url) {
              this.copyRequestId = (this.copyRequestId || 0) + 1;
              this.elements.successMessage.textContent = '';
              this.urlToShare = url;
              this.elements.urlInput.value = url;
            }
          }
        );

        scriptController.scripts.push('share.js');
      }
    });
  });
});